import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import SharedButton from '../../components/Shared/SharedButton';
import PurchasedEntryTable from './PurchasedEntryTable';
import { debounce } from '../../helpers/debounce';
import SearchField from '../../components/Shared/SearchField';
import useFetchData from '../../hooks/useFetchData';

export default function PurchasedEntryMain() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [selectedTransactionEntries, setSelectedTransactionEntries] = useState([]);
  const { data: purchasedEntryData, loading, executeFetch } = useFetchData();
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    executeFetch("POST", "list_purchased_entry", { page: 1, per_page: 10 });
  }, [executeFetch]);

  const handlePageChange = (newPage, newRowsPerPage) => {
    executeFetch("POST", "list_purchased_entry", {
      page: newPage,
      per_page: newRowsPerPage,
      query: searchValue.trim() || undefined
    });
  };

  const handleRefresh = () => {
    executeFetch("POST", "list_purchased_entry", {
      page: 1,
      per_page: 10,
      query: searchValue.trim() || undefined
    });
  };

  const handleSearch = event => {
    const value = event?.target?.value;
    setSearchValue(value);
    debouncedSearch(value);
  };

  const handleClearSearch = () => {
    setSearchValue('');
    executeFetch("POST", "list_purchased_entry", { page: 1, per_page: 10 });
  };

  // Debounced search function
  const debouncedSearch = useCallback(
    debounce(value => {
      executeFetch("POST", "list_purchased_entry", {
        query: value?.trim() || undefined,
        page: 1,
        per_page: 10
      });
    }, 500),
    [executeFetch]
  );

  return (
    <>
      <div>
        <div className='flex justify-end mb-2'>
          <div className='flex items-center gap-2'>
            <SearchField
              className="w-full md:!w-[300px]"
              placeholder={t(' Search by Name')}
              value={searchValue}
              onChange={handleSearch}
              handleClearClick={handleClearSearch}
            />
            <SharedButton
              label={t('CreatePurchasedEntry')}
              icon='pi pi-plus'
              onClick={() => navigate('/manager/purchased_entry/create')}
              className='bg-primary primary-btn'
            />
          </div>
        </div>
        <PurchasedEntryTable
          data={purchasedEntryData}
          loading={loading}
          onPageChange={handlePageChange}
          onRefresh={handleRefresh}
          selectedTransactionEntries={selectedTransactionEntries}
          setSelectedTransactionEntries={setSelectedTransactionEntries}
        />
      </div>
    </>
  );
}
